export const APP = 'CONNECT_MORE';
export const APP_CONTAINER = 'connect-more';
